import { SxProps, Theme } from '@mui/system';

const styles = {

  container: {
    padding: 0,
  },

} satisfies Record<string, SxProps<Theme>>;

export default styles;
